import { memo } from 'react'
import * as Styled from './styled'
import { ISidebarItemProps } from './types'
import { Text } from 'common-components'
import { NEW_LABEL_PNG } from 'consts/images'

const SidebarItem: React.FC<ISidebarItemProps> = ({
  icon,
  label,
  isActive,
  isNewLabel
}) => (
  <Styled.SidebarItem $isActive={isActive}>
    {icon}
    <Text
      type="h6"
      color={isActive ? 'secondaryDark' : 'secondarySemiDark'}
      fontWeight="500"
    >
      {label}
    </Text>
    {isNewLabel && <Styled.NewLabel src={NEW_LABEL_PNG} alt="New Label" />}
  </Styled.SidebarItem>
)

export default memo(SidebarItem)
